import React, { useEffect, useMemo, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import countryList from 'react-select-country-list'
import Dropdown from 'react-bootstrap/Dropdown';
import Layout from '../../components/Layout';
import PersonalOne from './PersonalOne';
import PersonalTwo from './PersonalTwo';
import PersonalThree from './PersonalThree';
import Payment from './Payment';
import BankInfo from './BankInfo';
import Investment from './Investment';
import Review from './Review';
import Helper from '../../helper';
import Select from 'react-select';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.css';
// import "../bootstrap/dist/js/bootstrap.bundle.min.js";
import Application from '../../services/application.service';

const Stepform = () => {
    const [progress, setProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const isformCout = parseInt(localStorage.getItem('formCount') ?? 1);
    const [formCount, setFormCount] = useState(isformCout);
    const [input, setInput] = useState({
        status: "",
        application_id: "",
        is_fetch_data: 0,
        salutation: "",
        first_name: "",
        last_name: "",
        id_type: "",
        id_number: "",
        phone: "",
        is_phone_verified: 0,
        email: "",
        is_email_verified: 0,
        gender: "",
        dob: "",
        nationality: "",
        matrial_status: "",
        income_tax_number: "",
        tax_refernce_number: "",
        country_of_residence: "",
        occupation: "",
        is_tax_number: "",
        address_1: "",
        address_2: "",
        suburb: "",
        city: "",
        postal_code: "",
        country: "",
        postal_address_1: "",
        postal_address_2: "",
        postal_suburb: "",
        postal_city: "",
        postal_postal_code: "",
        postal_country: "",
        payment_type: "",
        is_cheque_agree: "",
        annual_escalation: "",
        commencement_date: "",
        name: "",
        bank_type: "",
        bank_name: "",
        branch_name: "",
        branch_code: "",
        account_number: "",
        account_type: "",
        debit_order: "",
        amount: "",
        source_of_fund: "",
        other_fund_source: "",
        is_domenstic_prominent: "",
        domenstic_details: "",
        country_of_issue: "",
        tax_details: []
    });

    const countries = useMemo(() => countryList().getData(), [])
    const idTypeArr = [{ value: 'I', label: 'ID' }, { value: 'P', label: 'Passport' }]
    const salutationArr = [{ value: 'Mr', label: 'Mr.' }, { value: 'Ms', label: 'Ms.' }, { value: 'Mrs', label: 'Mrs.' }]
    const genderArr = [{ value: 'M', label: 'Male' }, { value: 'F', label: 'Female' }, { value: 'O', label: 'Other' }]
    const matrialArr = [
        { value: 'Single', label: 'Single' },
        { value: 'Married', label: 'Married' },
        { value: 'Widowed', label: 'Widowed' },
        { value: 'Divorced', label: 'Divorced' },
        { value: 'Separated', label: 'Separated' },
        { value: 'Registered Partnership', label: 'Registered Partnership' },
        { value: 'Anti-Nuptial Contract', label: 'Anti-Nuptial Contract' },
        { value: 'In Community of Property', label: 'In Community of Property' }
    ]

    const sideMenuList = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ]

    const progressBar = (val) => {
        setProgress(val)
    }

    useEffect(() => {
        localStorage.setItem('formCount', formCount);

        setIsLoading(true)
        Application.applicationInfo().then(res => {
            if (res.success === true) {
                var data = Helper.fillApplication(res.data.application, input);
                setInput({ ...data });

                var totalFields = Object.keys(data).length - 7;
                var fillFields = Helper.checkObject(data)
                let percentage = Math.round((fillFields / totalFields) * 100);
                setProgress(percentage > 100 ? 100 : (percentage >= 94 ? 100 : percentage));

                setIsLoading(false)
            }
        });
        if (formCount === 1 || formCount === 2 || formCount === 3) {
            setStepNumber(options[0])
        }
        else if (formCount === 4) {
            setStepNumber(options[1])
        }
        else if (formCount === 5) {
            setStepNumber(options[2])
        }
        else if (formCount === 6) {
            setStepNumber(options[3])
        }
        else if (formCount === 7) {
            setStepNumber(options[4])
        }
        // alert("sldlask")
    }, [formCount])

    const options = [
        { value: 'PD', label: 'Personal Details' },
        { value: 'ID', label: 'Investment Details' },
        { value: 'PayD', label: 'Payment Details' },
        { value: 'BD', label: 'Bank Details' },
        { value: 'Re', label: 'Review' }
    ]
    const [stepNumber, setStepNumber] = useState(options[0]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput({ ...input, [name]: value });
    }

    const handleChecked = (e) => {
        const { name, checked } = e.target;
        setInput({ ...input, [name]: checked });
    }

    const customStyles = {
        menu: (provided, state) => ({
            ...provided,
            width: state.selectProps.width,
            borderBottom: '1px dotted pink',
            color: 'red',
            padding: 20,
        }),
    }

    let prop = {
        setFormCount: setFormCount,
        setStepNumber: setStepNumber,
        progressBar: progressBar,
        setInput: setInput,
        input: input,
        isLoading: isLoading,
        idTypeArr: idTypeArr,
        salutationArr: salutationArr,
        genderArr: genderArr,
        matrialArr: matrialArr,
        handleChange: handleChange,
        handleChecked: handleChecked,
        countries: countries
    }

    const formChanges = (value) => {
        if (value.value === "PD") {
            setFormCount(1)
            setStepNumber(options[0])
        }
        else if (value.value === "ID") {
            setFormCount(4)
            setStepNumber(options[1])
        }
        else if (value.value === "PayD") {
            setFormCount(5)
            setStepNumber(options[2])
        }
        else if (value.value === "BD") {
            setFormCount(6)
            setStepNumber(options[3])
        }
        else if (value.value === "Re") {
            setFormCount(7)
            setStepNumber(options[4])
        }
    }

    return (
        <div className='form-page-wrapper'>
            <Layout>
                <section className="steps-indicator-section p-absolute w1-100">

                    <div className="container">
                        <div className="step-indicator-container">
                            <div className="row">
                                <div className='col-12'>

                                </div>
                                <div className="col-lg-3 col-md-4 pr-0 d-none d-md-block d-lg-block d-xl-block">
                                    <div className="step-bar-wrapper">
                                        <div className="form-progress-bar">
                                            <div className='d-flex progress-details' data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                                                <div className='percentage'>{progress}% Complete</div>
                                            </div>
                                            <div className='pb-3'>
                                                <ProgressBar now={progress} max={100} />
                                            </div>
                                        </div>
                                        <div className={(formCount === 1 || formCount === 2 || formCount === 3) ? "form-step d-flex active" : "form-step d-flex"} onClick={e => setFormCount(1)}>
                                            <div className="step-title">Personal Details</div>
                                        </div>
                                        <div className={(formCount === 4) ? "form-step d-flex active" : "form-step d-flex"} onClick={e => setFormCount(4)}>
                                            <div className="step-title">Investment Details</div>
                                        </div>
                                        <div className={(formCount === 5) ? "form-step d-flex active" : "form-step d-flex"} onClick={e => setFormCount(5)}>
                                            <div className="step-title">Payment Details</div>
                                        </div>
                                        <div className={(formCount === 6) ? "form-step d-flex active" : "form-step d-flex"} onClick={e => setFormCount(6)}>
                                            <div className="step-title">Bank Details</div>
                                        </div>
                                        <div className={(formCount === 7) ? "form-step d-flex active" : "form-step d-flex"} onClick={e => setFormCount(7)}>
                                            <div className="step-title">Review</div>
                                        </div>
                                        <div className='copyright'>
                                            <span>© 2022 Differential Capital All Rights Reserved.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Select options={options} className="top-select-menu" placeholder={'Select'} isSearchable={false} onChange={(value, e) => formChanges(value, e)} value={stepNumber} />

                <section className="step-form-section">
                    <div className="container step-form-container">
                        <div className='step-form-wrapper'>
                            <div className='row'>
                                <div className="col-lg-3 col-md-4 pr-0 d-none d-md-block d-lg-block d-xl-block zIndex-neg1"> </div>
                                <div className='col-lg-9 col-md-8 col-sm-12 p-0'>
                                    <div className="form-steps-wrapper">

                                        <div className='progress-bar-wrapper'>
                                            <div className="collapse step-bar-mobile mt-3" id="collapseExample">
                                                <div className="card card-body">
                                                    <div className='step-indicator'>
                                                        <div className={`step-title ${(formCount >= 1) ? "completed" : ""}`} >Personal Detail</div>
                                                        <div className={`step-title ${(formCount >= 4) ? "completed" : ""}`}>Investment Detail</div>
                                                        <div className={`step-title ${(formCount >= 5) ? "completed" : ""}`}>Payment Detail</div>
                                                        <div className={`step-title ${(formCount >= 6) ? "completed" : ""}`}>Bank Detail</div>
                                                        <div className={`step-title ${(formCount >= 7) ? "completed" : ""}`}>Review</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="step-forms-container">
                                            {/* <Dropdown className="drop-down-top d-none">
                                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                    Dropdown Button
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item  onClick={e => setFormCount(1)}>Personal Details</Dropdown.Item>
                                                    <Dropdown.Item onClick={e => setFormCount(4)}>Investment Details</Dropdown.Item>
                                                    <Dropdown.Item onClick={e => setFormCount(5)}>Payment Details</Dropdown.Item>
                                                    <Dropdown.Item onClick={e => setFormCount(6)}>Bank Details</Dropdown.Item>
                                                    <Dropdown.Item onClick={e => setFormCount(7)}>Review</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown> */}
                                            {isLoading ? Helper.ShowLoader() :
                                                <div className="form-container" style={{ position: "unset" }}>
                                                    {(formCount === 1) && <PersonalOne {...prop}></PersonalOne>}
                                                    {(formCount === 2) && <PersonalTwo {...prop}></PersonalTwo>}
                                                    {(formCount === 3) && <PersonalThree {...prop}></PersonalThree>}
                                                    {(formCount === 4) && <Investment {...prop}></Investment>}
                                                    {(formCount === 5) && <Payment {...prop}></Payment>}
                                                    {(formCount === 6) && <BankInfo {...prop}></BankInfo>}
                                                    {(formCount === 7) && <Review {...prop}></Review>}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div >
    )
}

export default Stepform;